// types
import React from "react";

import { useAuth } from "@/customHooks/useAuth";
import Image from "next/image";
import type { Recipe } from "~types/recipe";

import { Avatar, Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";

import Pan from "~public/icons/Pan/Pan.svg";

interface RecipePanProps {
  recipe: Recipe;
  selected: boolean;
  onSelect: Function;
}

export const RecipePanSelectable = ({
  recipe,
  selected,
  onSelect
}: RecipePanProps): JSX.Element => {
  const { title, user, user_saved_recipe } = recipe;
  const { avatar, first_name, last_name, avatar_thumbnail_55 } = user;
  const theme = useTheme();
  const { session } = useAuth();

  const panColor = () => {
    if (recipe.convenience_level?.[0]) {
      return theme.palette.green.main;
    }
    if (recipe.convenience_level?.[1]) {
      return theme.palette.pink.main;
    }
    if (recipe.convenience_level?.[2]) {
      return theme.palette.orange.main;
    }

    return theme.palette.gray.main;
  };

  return (
    <Box
      id={`recipe-pan_selectable-${recipe.pk}`}
      data-qa={"recipe-pan-selectable"}
      className="recipe_pan"
      onClick={() => onSelect(recipe.pk)}
      sx={{
        position: "relative",
        width: "min-content",
        height: 115,
        overflow: "visible",
        "& .pan path": { fill: panColor() },
        "& .pan": {
          transform: selected ? "rotate(-90deg)" : "none"
        },
        "& .pan ": { transition: "all 600ms ease-in-out" },
        "& .avatar": { opacity: selected ? 100 : 0 },
        display: "flex",
        alignItems: "center",
        maxWidth: "calc(50% - 16px)"
      }}>
      <Pan
        className="pan"
        style={{
          fontSize: 115,
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1
        }}
      />
      <Avatar
        className="avatar"
        sx={{
          boxShadow: `0 0 32px 50px ${alpha(theme.palette.green.main, 0.2)}`,
          position: "absolute",
          width: 55,
          height: 55,
          top: 23,
          left: 20,
          opacity: 0,
          transition: "all 600ms ease-in-out",
          zIndex: -2
        }}>
        {avatar_thumbnail_55 && (
          <Image
            src={avatar_thumbnail_55.toString()}
            layout={"fill"}
            // width={55}
            // height={55}
            objectFit={"cover"}
            alt="avatar"
            // blurDataURL={
            //   "iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP89OhRPQAIuwM37os1UAAAAABJRU5ErkJggg=="
            // }
            // placeholder={"blur"}
          />
        )}
      </Avatar>
      <Box
        className="info_block"
        sx={{
          mb: 2.5,
          position: "relative",
          width: "100px",
          ml: 7,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "center",
          transition: "all 600ms ease-in-out"
        }}>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 600,
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 4
          }}>
          {title}
        </Typography>
      </Box>
    </Box>
  );
};

export default RecipePanSelectable;
